export function pendingRecipes() {
  return Array.from(
    document.querySelectorAll('input[name="recipe"]:checked')
  ).map((input) => input.value);
}

export function detectTransition(originalRecipes, transitionMappings, pending) {
  const original = new Set(originalRecipes || []);
  const added = pending.filter((r) => !original.has(r));
  if (added.length === 0) return false;
  return (transitionMappings || []).some(([a, b]) => {
    return (
      (original.has(a) && added.includes(b)) ||
      (original.has(b) && added.includes(a))
    );
  });
}
